import {Button} from 'platform/components';
import {Box, Display, Hide, HStack, Image, Text, VStack} from 'platform/foundation';

import {suffixTestId, TestIdProps, useOnMount} from 'shared/web';

import i18n from '../../i18n/i18n';

interface ErrorPageProps extends TestIdProps {
  isNotFound?: boolean;
}

export function ErrorPage(props: ErrorPageProps) {
  useOnMount(() => {
    document.getElementById('loading-screen')?.remove();
  });

  return (
    <Box backgroundColor="palettes.blue.70.100" height="100vh">
      <HStack justify="center" align="center" height="100%">
        <Box maxWidth={150} padding={6}>
          <VStack spacing={6} align="center">
            <Image
              src="assets/images/logo.svg"
              width={38}
              data-testid={suffixTestId('error', props)}
            />
            <Display
              size={1}
              color="white"
              align="center"
              data-testid={suffixTestId('error', props)}
            >
              {props.isNotFound ? '404' : i18n.t('page.error.labels.errorHeading')}
            </Display>
            <Text color="white" align="center" data-testid={suffixTestId('error', props)}>
              {props.isNotFound
                ? i18n.t('page.error.labels.notFound')
                : i18n.t('page.error.labels.errorDescription')}
            </Text>
            <Hide when={props.isNotFound}>
              <Button
                title={i18n.t('page.error.labels.errorButton')}
                onClick={() => window.location.reload()}
              />
            </Hide>
          </VStack>
        </Box>
      </HStack>
    </Box>
  );
}
